import { css, createGlobalStyle } from 'styled-components';

import { Colors } from './ui';

export const GlobalScrollYLock = createGlobalStyle`
  body {
    overflow-y: hidden;
  }
`;

export const scrollbarMixin = (width: number, trackColor: string) => css`
  &::-webkit-scrollbar-track {
    background-color: ${trackColor};
    border-radius: ${width / 2}rem;
  }
  &::-webkit-scrollbar {
    width: ${width}rem;
    height: ${width}rem;
    border-radius: ${width / 2}rem;
    background-color: ${trackColor};
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${width / 2}rem;
    background-color: ${Colors.greyDarker};
  }
`;

export const styledScrollbarMixin = scrollbarMixin(0.8, Colors.greyLighter);
